import React from "react";
import dopplerIcon from "../assets/doppler_chat_logo.svg";
import type { CatalogDocument } from "../hooks/useDocumentMention";
import MessageInput from "./MessageInput";
import "./HeroSection.css";

interface HeroSectionProps {
	input: string;
	isLoading: boolean;
	onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	onSubmit: (e: React.FormEvent) => void;
	onKeyPress: (e: React.KeyboardEvent) => void;
	onSuggestionClick?: (message: string) => void;
	variant?: "default" | "side-panel";
	selectedDocs?: CatalogDocument[];
	onDocRemove?: (docId: string) => void;
	mentionDropdown?: React.ReactNode;
}

const HeroSection: React.FC<HeroSectionProps> = ({
	input,
	isLoading,
	onInputChange,
	onSubmit,
	onKeyPress,
	variant,
	selectedDocs,
	onDocRemove,
	mentionDropdown,
}) => {
	return (
		<div
			className={`hero-section-container ${
				variant === "side-panel" ? "hero-side-panel" : ""
			}`}
		>
			<div className="hero-section-content">
				{/* Hero Text Section — bottom-aligned inside the top spacer so the
				    input bar below sits at the exact vertical center */}
				<div className="hero-top-spacer">
					<div className="hero-text-container">
						<span className="hero-text-gray">How can</span>

						<img
							src={dopplerIcon}
							alt="Doppler chat icon"
							className="hero-icon"
						/>

						<span className="hero-text-green">Doppler</span>

						<span className="hero-text-black">help you?</span>
					</div>
				</div>

				{/* Input Container */}
				<div
					className={`w-full mx-auto ${
						variant === "side-panel" ? "p-0 side-panel-form" : "p-4"
					}`}
				>
					<MessageInput
						input={input}
						isLoading={isLoading}
						onInputChange={onInputChange}
						onSubmit={onSubmit}
						onKeyPress={onKeyPress}
						placeholder="Ask a question about your documents or data..."
					selectedDocs={selectedDocs}
					onDocRemove={onDocRemove}
					mentionDropdown={mentionDropdown}
					/>
				</div>

				<div className="hero-bottom-spacer" />
			</div>
		</div>
	);
};

export default HeroSection;
